import { render } from "./AdminBaseLayout.vue?vue&type=template&id=3c07abbf&scoped=true"
const script = {}

import "./AdminBaseLayout.vue?vue&type=style&index=0&id=3c07abbf&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c07abbf"]])

export default __exports__